<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Prática de Linguagem
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Prática de Linguagem*"
                  counter="100"
                  maxlength="100"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="content.habilidades"
                  label="Código da Habilidade*"
                  outlined
                  dense
                  multiple
                  hide-details="auto"
                  item-text="codigo"
                  item-value="id"
                  return-object
                  :items="form.lists.listHabilidades"
                  :rules="[(p) => p.some(v => $required(v)) || 'Campo obrigatório']"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="d-flex mt-0">
              <v-col cols="12">
                <span class="small"><v-icon small>mdi-gesture-double-tap</v-icon> Habilidade(s) Selecionada(s)</span>
                <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="(habilidade, i) in content.habilidades" :key="i" @click="selecionarChip(habilidade)">
                    <v-icon small>mdi-checkbox-marked-circle-outline</v-icon> {{ habilidade.codigo }}
                  </v-chip>
                </v-chip-group>
                <span v-if="descricaoHabilidadeSelecionada && content.habilidades?.length">
                  <span class="small"><v-icon small>mdi-alert-circle-check-outline</v-icon> Informações da Habilidade Selecionada</span>
                  <v-chip-group column>
                    <v-chip>{{ descricaoHabilidadeSelecionada }}</v-chip>
                  </v-chip-group>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="content.descricao"
                  label="O que será avaliado*"
                  maxlength="2500"
                  counter="2500"
                  rows="4"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 2500)]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { PraticaLinguagem } from '~/commons/classes/pratica-linguagem';
import HabilidadeService from '~/services/habilidade.service';
import PraticasLinguagemService from '~/services/praticas-linguagem.service';

export default {
  props: new DialogProps(PraticaLinguagem),
  mixins: [PraticasLinguagemService, HabilidadeService],
  data: () => ({
    form: {
      lists: {
        listHabilidades: []
      }
    },
    descricaoHabilidadeSelecionada: null
  }),
  watch: {
    visible(v) {
      v ? this.buscarHabilidades() : this.$emit("onClose");
    },
    "content.habilidades": function() {
      this.descricaoHabilidadeSelecionada = null;
    }
  },
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          return this.edit
            ? this.$editarPraticaLinguagem(new PraticaLinguagem(this.content).formatParaEnviar(), this.content.id)
            : this.$cadastrarPraticaLinguagem(new PraticaLinguagem(this.content).formatParaEnviar());
        });
      };
      if (this.$validarFormulario('Todos os campos obrigatórios devem ser preenchidos.')) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    buscarHabilidades() {
      this.$buscarHabilidades().then(({ data }) => {
        this.form.lists.listHabilidades = data.itens.filter(habilidade => {
          return habilidade.ativo ? habilidade: this.content.habilidades.find(h => h.id === habilidade.id);
        });
      });
    },
    selecionarChip(habilidade) {
      this.descricaoHabilidadeSelecionada = (this.descricaoHabilidadeSelecionada === habilidade?.descricao) ? null : habilidade?.descricao;
    }
  }
};
</script>
